import { render, staticRenderFns } from "./component-order-detaile.vue?vue&type=template&id=045b36bc"
import script from "./component-order-detaile.vue?vue&type=script&lang=js"
export * from "./component-order-detaile.vue?vue&type=script&lang=js"
import style0 from "./component-order-detaile.vue?vue&type=style&index=0&id=045b36bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports